import { SET_LOADING, SET_PERFIL } from './mutation-types'
import perfilService from '@/services/perfil/perfilService'

export default {
    fetch({ commit }, { errorCallback }) {
        commit(SET_LOADING, true);
        perfilService.fetch()
            .then(res => commit(SET_PERFIL, res.data))
            .catch(error => errorCallback && errorCallback())
            .finally(res => commit(SET_LOADING, false));
    }
}